import {DateTime} from 'luxon';

import {useConstant} from '../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {useEventHandler} from '../../libs/shared/helpers/src/react/hooks/useEventHandler';
import {findTimeZone} from '../../src/helpers/dateTimeHelpers';
import {
  setDoNotDisturbEnd,
  setDoNotDisturbStart,
  tryFindDoNotDisturbInterval,
} from '../../src/helpers/models/doNotDisturbHelpers';
import {useAppDispatch, useAppSelector} from '../../src/helpers/reduxHelpers';
import {updateDoNotDisturbAction} from '../../src/store/data/preferences/preferencesActions';
import {getDoNotDisturb} from '../../src/store/data/preferences/preferencesSelectors';

/*
 * Hooks.
 */

export function useDoNotDisturb() {
  const dispatch = useAppDispatch();
  const doNotDisturb = useAppSelector(getDoNotDisturb);

  const onIsEnabledChange = useEventHandler((isEnabled: boolean) => {
    dispatch(updateDoNotDisturbAction({...doNotDisturb, isEnabled}));
  });

  // TODO: Do we still need findTimeZone() or can we just rely on Luxon to determine the local time zone?
  const now = useConstant(() => DateTime.now().setZone(findTimeZone()));
  const interval = tryFindDoNotDisturbInterval(now, doNotDisturb);
  const onStartTimeChange = useEventHandler((time: DateTime) => {
    dispatch(updateDoNotDisturbAction(setDoNotDisturbStart(doNotDisturb, time)));
  });
  const onEndTimeChange = useEventHandler((time: DateTime) => {
    dispatch(updateDoNotDisturbAction(setDoNotDisturbEnd(doNotDisturb, time)));
  });

  return {
    isEnabled: doNotDisturb.isEnabled,
    onIsEnabledChange,
    interval,
    onStartTimeChange,
    onEndTimeChange,
  };
}
